import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/sections/page-hero'
import { Booking } from '@/components/sections/booking'
import { Faq } from '@/components/sections/faq'

const BookFreeConsultation: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Free estimate'
                description='Request a free, no-obligation painting estimate from NG Painting Pro in New Bedford, MA. We reply within 24 hours with an itemized, detailed quote.'
            />

            <PageHero title='Get your free painting estimate' titleModifier='booking' />

            <Booking />
            <Faq />
        </Layout>
    )
}

export default BookFreeConsultation
